import React, { useState } from 'react';
import { Sparkles } from 'lucide-react';
import { useLanguageStore } from '../store/languageStore';

interface MatchBadgeProps {
  percentage: number;
}

const MatchBadge: React.FC<MatchBadgeProps> = ({ percentage }) => {
  const { selectedLanguage } = useLanguageStore();
  const [showTooltip, setShowTooltip] = useState(false);

  const messages = {
    EN: {
      match: "Match",
      tooltip: "AI-powered relevance score: based on your ZIP code, income, and need."
    },
    ES: {
      match: "Coincidencia",
      tooltip: "Puntuación de relevancia por IA: basada en tu código postal, ingresos y necesidad."
    },
    ZH: {
      match: "匹配度",
      tooltip: "AI驱动的相关性评分：基于您的邮政编码、收入和需求。"
    },
    VI: {
      match: "Phù hợp",
      tooltip: "Điểm liên quan được hỗ trợ bởi AI: dựa trên mã ZIP, thu nhập và nhu cầu của bạn."
    },
    FIL: {
      match: "Tugma",
      tooltip: "AI-powered na score ng kaugnayan: batay sa iyong ZIP code, kita, at pangangailangan."
    },
    KO: {
      match: "매칭",
      tooltip: "AI 기반 관련성 점수: 우편번호, 소득, 필요성을 기준으로 합니다."
    },
    AR: {
      match: "تطابق",
      tooltip: "درجة الملاءمة المدعومة بالذكاء الاصطناعي: بناءً على الرمز البريدي والدخل والاحتياج."
    }
  };

  const getMatchColor = (percentage: number) => {
    if (percentage >= 80) return 'bg-green-50 border-green-100 text-green-700';
    if (percentage >= 60) return 'bg-yellow-50 border-yellow-100 text-yellow-700';
    return 'bg-red-50 border-red-100 text-red-700';
  };

  return (
    <div className="relative inline-block">
      <div 
        className={`match-badge ${getMatchColor(percentage)} flex items-center gap-1.5`}
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
      >
        <span>{percentage}% {messages[selectedLanguage].match}</span>
        <Sparkles className="w-3.5 h-3.5 sm:w-4 sm:h-4" />
      </div>
      
      {showTooltip && (
        <div className="absolute bottom-full left-0 mb-2 w-48 sm:w-64 -translate-x-1/4 bg-gray-900 text-white text-[10px] sm:text-sm rounded-lg p-2 shadow-lg animate-fade-in z-50">
          {messages[selectedLanguage].tooltip}
          <div className="absolute bottom-0 left-4 transform translate-y-full border-4 border-transparent border-t-gray-900" />
        </div>
      )}
    </div>
  );
};

export default MatchBadge;